module.exports = __webpack_public_path__ + "media/img/Landing_Page/S2U-Emirah-Arjunaidi-Jamaludin-e6954213a408376f1797d898706558b5.jpg";